<template>
    <h2>Thank you for registering</h2>

    <p>Thank you for completing your registration. You may now begin using the Ultra Librarian App.</p>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'CompleteConfirmation',
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: "/" + this.$route.params.instance, options: localOptions });
            },
        },
        mounted() {
            this.$store.commit('SET_RETURNURL', "/" + this.$route.params.instance);
        }
    }
</script>

<style scoped>
</style>